import { Box, Button, Flex, Select, Text } from "@mantine/core";
import { IoIosArrowBack } from "react-icons/io";
import FormFieldComponent from "./FormFieldComponent";
import PushNotificationEvents from "../enums/PushNotificationEvents";
import { PushNotificationRequest } from "../models/PushNotificationRequest";

interface PushNotificationFormProps {
  setFilterApplied: (newValue: boolean) => void;
  notification: PushNotificationRequest;
  setNotification: (newValue: PushNotificationRequest) => void;
  formInvalid: boolean;
  setFormInvalid: (newValue: boolean) => void;
  invalidFields: string[];
  setInvalidFields: (newValue: string[]) => void;
}

export const PushNotificationForm = ({
  setFilterApplied,
  notification,
  setNotification,
  formInvalid,
  setFormInvalid,
  invalidFields,
  setInvalidFields
}: PushNotificationFormProps) => {
  const options = Object.values(PushNotificationEvents).map((event) => event);

  const handleTitleChange = (_field: string, value: string) => {
    setNotification({ ...notification, title: value });
  };

  const handleBodyChange = (_field: string, value: string) => {
    setNotification({ ...notification, body: value });
  };

  const handleWebLinkChange = (_field: string, value: string) => {
    setNotification({ ...notification, webLink: value });
  };

  return (
    <Flex direction="column" justify="center" align="center">
      <Button
        leftSection={<IoIosArrowBack />}
        onClick={() => {
          setInvalidFields([]);
          setFormInvalid(false);
          setFilterApplied(false);
        }}
        mb="md"
      >
        Go back to filter
      </Button>
      <FormFieldComponent
        label="Notification Title:"
        placeholder="Title goes here!"
        value={notification.title}
        onChange={handleTitleChange}
        field="title"
        type="textarea"
        disabled={false}
        maxLength={250}
      />
      <FormFieldComponent
        label="Notification Body:"
        placeholder="Body goes here!"
        value={notification.body}
        onChange={handleBodyChange}
        field="body"
        type="textarea"
        disabled={false}
        maxLength={990}
      />

      <Box w="100%">
        <Select
          styles={{ root: { display: "block" } }}
          label="Event Type:"
          data={options}
          value={notification.notificationEvent}
          onChange={(value) => {
            const newEvent = value as PushNotificationEvents;

            setNotification({
              ...notification,
              notificationEvent: newEvent,
              webLink: newEvent === "WEB_LINK" ? notification.webLink : "",
            });
          }}
        />
      </Box>

      <FormFieldComponent
        label="Web URL (only for WEB_LINK):"
        placeholder="Enter a valid URL"
        value={notification.webLink}
        onChange={handleWebLinkChange}
        field="link"
        type="textarea"
        disabled={
          notification.notificationEvent !==
          PushNotificationEvents.WEB_LINK
        }
      />
      <Box h={30}>
        {formInvalid ? (
          <Text c="red" className="pushnotifications-invalid">
            Invalid fields: {invalidFields.join(", ")}
          </Text>
        ) : null}
      </Box>
    </Flex>
  );
};
